import { combineLatest as observableCombineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import * as actions from '../../store/actions/index';
import * as selectors from '../../store/reducers/index';
var StaffComponent = /** @class */ (function () {
    function StaffComponent(store, route) {
        this.store = store;
        this.route = route;
    }
    StaffComponent.prototype.ngOnInit = function () {
        var id = this.route.snapshot.params.id;
        this.store.dispatch(actions.Staff.SelectByIdAction({ id: id }));
        this.store.dispatch(actions.Staff.RequestByIdAction({ id: id }));
        this.loading$ = this.store
            .select(selectors.getLoadingEntities(selectors.STAFF)).pipe(map(function (loading) { return loading[id]; }));
        this.staff$ = this.store.select(selectors.getSelected(selectors.STAFF));
        this.admin$ = this.store.select(selectors.isOrgAdmin);
        this.isOwnAccount$ = observableCombineLatest(this.staff$, this.store.select(selectors.getAuthenticationState)).pipe(map(function (_a) {
            var staff = _a[0], auth = _a[1];
            return (staff ? auth.auth && staff.id === auth.auth.userId : false);
        }));
    };
    StaffComponent.prototype.submitStaff = function (payload) {
        this.store.dispatch(actions.Staff.RequestUpdateRole({ id: this.route.snapshot.params.id, role: payload }));
    };
    return StaffComponent;
}());
export { StaffComponent };
